(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('FpasSeries', FpasSeries);

    FpasSeries.$inject = ['$resource', 'DateUtils'];

    function FpasSeries ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data/fpas';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
